import { useAtomValue } from 'jotai';
import { ButtonGroup, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import * as poiState from '../../pointOfInterest/state';
import { useCuboidState } from '../hooks';
import { useAnalysisCuboidActions } from '../hooks/useAnalysisCuboidActions';
import { OutlinedIconButton } from '@/modules/cuboids/components/CuboidToolbar/styles';

export const CuboidDoneButtonGroup = () => {
  const cuboidState = useCuboidState();

  const currentCuboid = useAtomValue(cuboidState.currentCuboid);

  const { cancelAddingCuboid, doneAddingCuboid, stopEditingPoiCuboids } =
    useAnalysisCuboidActions();

  const editPointOfInterest = useAtomValue(poiState.editPointOfInterest);

  const handleCancelCuboid = () => {
    const isEditingPoi = editPointOfInterest?.formState === 'Update-General';
    if (isEditingPoi) {
      stopEditingPoiCuboids(editPointOfInterest.pointOfInterest);
    } else {
      cancelAddingCuboid();
    }
  };

  return (
    <>
      <ButtonGroup sx={{ paddingBottom: '10px' }}>
        <Tooltip title="Cancel">
          <OutlinedIconButton onClick={handleCancelCuboid} disabled={!currentCuboid}>
            <CloseIcon style={{ color: '#fff' }} />
          </OutlinedIconButton>
        </Tooltip>

        <Tooltip title="Done">
          <OutlinedIconButton onClick={doneAddingCuboid} disabled={!currentCuboid}>
            <SaveIcon style={{ color: '#fff' }} />
          </OutlinedIconButton>
        </Tooltip>
      </ButtonGroup>
    </>
  );
};
